module.exports = __webpack_public_path__ + "static/web_application_development-20e9070d435f2596206f317d24b27d43.png";